namespace Matrix.Data {
    export interface SecurityMergeSourceRow {
        SourceCode?: string;
        SelfMatch?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        SourceName?: string;
    }

    export namespace SecurityMergeSourceRow {
        export const idProperty = 'SourceCode';
        export const nameProperty = 'SourceName';
        export const localTextPrefix = 'Data.SecurityMergeSource';
        export const deletePermission = 'DataAdmin:SecurityMergeSource';
        export const insertPermission = 'DataAdmin:SecurityMergeSource';
        export const readPermission = 'Read:SecurityMergeSource';
        export const updatePermission = 'DataAdmin:SecurityMergeSource';

        export declare const enum Fields {
            SourceCode = "SourceCode",
            SelfMatch = "SelfMatch",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            SourceName = "SourceName"
        }
    }
}
